import type { ExternalId } from "../interface/publications"

export const isExternalId = (value: unknown): value is ExternalId =>
  typeof value === "number"
    ? Number.isSafeInteger(value) && value > 0
    : typeof value === "string" && /^[1-9][0-9]*$/.test(value)

/** Comparison key only. Keep the original representation in wire DTOs. */
export const externalIdKey = (value: unknown): string => {
  if (!isExternalId(value)) throw new TypeError("Invalid external ID")
  return String(value)
}
